import React, { Fragment, useState } from "react";
import { styled } from "@mui/material/styles";
import { Carousel } from "react-responsive-carousel";
import { Typography } from "@mui/material";

import "react-responsive-carousel/lib/styles/carousel.min.css";

const PREFIX = "ImageCarousel";

const classes = {
  outerDiv: `${PREFIX}-outerDiv`,
  img: `${PREFIX}-img`,
  caption: `${PREFIX}-caption`,
  thumbImg: `${PREFIX}-thumbImg`,
};

const CarouselRoot = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "100%",
  maxWidth: "100vw",
  [`& .${classes.outerDiv}`]: {
    display: "flex",
    alignItems: "center",
    width: "calc(100%-70px)",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100vw",
    },
  },

  [`& .${classes.img}`]: {
    width: 550,
    height: 550,
    objectFit: "cover",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100vw",
    },
  },

  // css below adapted from react-responsive-carousel
  [`& .${classes.caption}`]: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    padding: theme.spacing(1, 2),
    transition: "opacity 0.35s ease-in-out",
    color: "#fff",
    backgroundColor: "#000",
    opacity: 0.6,
    textAlign: "center",
    wordWrap: "break-word",
    "&:hover": {
      opacity: 1,
    },
  },

  [`& .${classes.thumbImg}`]: {
    objectFit: "cover",
    width: 70,
    height: 70,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const CustomThumbsRoot = styled("div")(({ theme }) => ({
  display: "flex",
  minWidth: 70,
  maxHeight: "100%",
  overflow: "hidden",
  overflowY: "scroll",
  scrollbarWidth: "none",
  "-ms-overflow-style": "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("sm")]: {
    flexDirection: "row",
    overflowX: "scroll",
  },
}));

const ImageCarousel = ({ images, showThumbs }) => {
  const [selectedImage, setSelectedImage] = useState(0);

  if (!images || !images.length > 0) {
    return <Fragment />;
  }

  const CustomThumbs = () => {
    return (
      <CustomThumbsRoot>
        {images.map((img, index) => (
          <img
            key={index}
            src={img.image}
            alt={`image-${index}`}
            className={classes.thumbImg}
            onClick={() => setSelectedImage(index)}
            style={{ opacity: selectedImage === index ? 1 : 0.4 }}
          />
        ))}
      </CustomThumbsRoot>
    );
  };

  return (
    <CarouselRoot>
      <Carousel
        showArrows
        useKeyboardArrows
        swipeable
        emulateTouch
        showIndicators={false}
        showThumbs={false}
        showStatus={false}
        autoPlay={false}
        dynamicHeight={false}
        infiniteLoop={false}
        selectedItem={selectedImage}
        onChange={(image) => setSelectedImage(image)}
        style={{ flex: 1 }}
      >
        {images.map((img, index) => {
          return (
            <div key={index} className={classes.outerDiv}>
              <img src={img.image} alt={`image-${index}`} className={classes.img} />
              {img.image_caption && (
                <div className={classes.caption}>
                  <Typography variant="body2">{img.image_caption}</Typography>
                </div>
              )}
            </div>
          );
        })}
      </Carousel>
      {showThumbs && images.length > 1 && <CustomThumbs />}
    </CarouselRoot>
  );
};

export default ImageCarousel;
